
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-wizard-stepper',
  templateUrl: './wizard-stepper.component.html',
  styleUrls: ['./wizard-stepper.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [MatIconModule],
})
export class WizardStepperComponent {
  @Input() steps: string[] = [];
  @Input() current = 1;
  @Input() completed: number[] = [];
  @Output() stepClick = new EventEmitter<number>();

  isDone(index: number): boolean {
    return this.completed.includes(index + 1);
  }

  isActive(index: number): boolean {
    return index + 1 === this.current;
  }

  onClick(index: number): void {
    const step = index + 1;
    if (step === this.current) return;
    this.stepClick.emit(step);
  }
}
